<template>
    <!-- class="easy-love" -->
    <div
        :style="{
            'font-family': wall.fontFamily,
            'background-color': wall.transparentBackground ? 'transparent' : wall.wallColor,
        }"
    >
        <div
            class="wall py-12 sm:py-16 lg:py-24 px-4 sm:px-16 overflow-hidden"
            :class="[showMultislider ? 'pt-2 sm:pt-6 lg:pt-8' : 'max-w-7xl mx-auto']"
        >
            <div
                v-if="(!wall.hideTitle && wall.wallTitle) || wall.wallSubtitle"
                class="space-y-4 pb-12 text-center"
                :class="[showMultislider ? 'max-w-7xl mx-auto px-2 sm:px-6 lg:px-8 ' : '']"
                :style="{ color: wall.titleColor }"
            >
                <cUtilsEdit
                    v-if="!wall.hideTitle && wall.wallTitle"
                    @edit="goToWallField('wallTitle')"
                >
                    <h2 class="text-2xl sm:text-3xl lg:text-4xl font-semibold">
                        {{ wall.wallTitle }}
                    </h2>
                </cUtilsEdit>
                <cUtilsEdit v-if="wall.wallSubtitle" @edit="goToWallField('wallSubtitle')">
                    <p class="text-base font-regular opacity-80">
                        {{ wall.wallSubtitle }}
                    </p>
                </cUtilsEdit>
            </div>
            <LoveSlider v-if="finalLayout === 'slider'" :wall="wall" />
            <LoveBoard
                v-if="finalLayout === 'board'"
                :wall="wall"
                @updateIframe="$emit('updateIframe')"
            />
            <LoveMultislider
                v-if="finalLayout === 'multislider'"
                :wall="wall"
                @updateIframe="$emit('updateIframe')"
            />
            <LoveBigslider v-if="finalLayout === 'bigslider'" :wall="wall" />
            <LoveAvatars
                v-if="finalLayout === 'avatars'"
                :wall="wall"
                @updateIframe="$emit('updateIframe')"
            />

            <!-- Footer -->
            <div class="mt-12 w-full flex flex-col md:flex-row items-center">
                <div
                    class="order-2 md:order-1 flex-grow space-x-3 flex items-center mt-8 md:mt-0 md:mr-3"
                >
                    <EasyLogoIcon
                        v-if="!hideLogo && wall.showFooter"
                        class="flex-shrink-0 text-love-500 h-8 w-8"
                    />
                    <p
                        v-if="!hideLogo && wall.showFooter"
                        class="flex-grow text-sm"
                        :style="{ color: wall.titleColor }"
                    >
                        <!--                        {{ $t("r_shared.made_with") }}-->
                        <a
                            class="underline"
                            href="https://easy.tools/love"
                            @click.prevent="gotoLink('https://easy.tools/love')"
                            >Easylove</a
                        >
                    </p>
                </div>
                <div class="order-1 md:order-2 flex flex-col md:flex-row">
                    <a
                        href="https://easy.tools/love"
                        @click.prevent="gotoLink('https://easy.tools/love')"
                        v-if="wall.showFooter"
                        :style="{
                            borderColor: wall.borderColor,
                            color: wall.titleColor,
                            'border-radius': wall.borderRadius + 'px',
                        }"
                        type="button"
                        class="order-2 md:order-1 border ct-btn-sm opacity-90 hover:opacity-100 mt-3 md:mt-0 md:mr-3"
                    >
                        <LoveIcon />
                        <span> {{ $t("r_love.create_wall") }} </span>
                    </a>
                    <a
                        :href="`/review-ask/${this.wall.uuid}`"
                        @click.prevent="gotoLink(`/review-ask/${this.wall.uuid}`)"
                        v-if="wall.showCreateLink"
                        :style="{
                            borderColor: wall.borderColor,
                            color: wall.titleColor,
                            'border-radius': wall.borderRadius + 'px',
                        }"
                        type="button"
                        class="order-1 md:order-2 border ct-btn-sm opacity-90 hover:opacity-100"
                    >
                        <AddIcon />
                        <span> {{ $t("r_love.create_review") }} </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { handleLinkClick } from "@/shared/utils";
import LoveBoard from "./LoveBoard.vue";
import LoveSlider from "./LoveSlider.vue";
import LoveMultislider from "./LoveMultislider.vue";
import LoveBigslider from "./LoveBigslider.vue";
import LoveAvatars from "./LoveAvatars.vue";
import { EasyLogoIcon, LoveIcon, AddIcon } from "@easy/ui/icons";
import cUtilsEdit from "@/views/shared/cUtilsEdit.vue";
import { useLoveGoTo } from "@/views/tools/love/utils/useLoveGoTo";
import { windowService } from "@/shared/connection/window.service";

export default {
    name: "LoveWallBody",
    components: {
        LoveBoard,
        LoveSlider,
        LoveMultislider,
        EasyLogoIcon,
        LoveIcon,
        AddIcon,
        LoveBigslider,
        cUtilsEdit,
        LoveAvatars,
    },
    setup() {
        const { goToWallField } = useLoveGoTo();
        return { goToWallField };
    },
    props: {
        wall: Object,
        hideLogo: Boolean,
    },
    emits: ["updateIframe"],
    data() {
        return {
            currentView: this.$route.query.layout,
        };
    },
    mounted() {
        // declare CSS var topmost for [EAS-2059] fix.
        document.documentElement.style.setProperty(
            "--glightbox-height",
            windowService.isInIFrame() ? "auto" : "100%"
        );
    },
    computed: {
        ...mapState("shared/view", ["preview"]),
        notHidedTestimonials() {
            return this.wall.testimonials.filter((x) => !x.hide && !x._deleted);
        },
        showMultislider() {
            return this.wall.layout === "multislider";
        },
        finalLayout() {
            return this.currentView || this.wall.layout;
        },
        gLightboxFixVideoWhenInIframe() {
            return windowService.isInIFrame() ? "red" : "green";
        },
    },
    methods: {
        gotoLink(url) {
            handleLinkClick(url, this.preview);
        },
    },
};
</script>

<style>
/* [EAS-2059] hack */
.gcontainer .gslider {
    height: var(--glightbox-height) !important;
}
</style>
